import { KnownError } from '../api/errors';
import { linkPartner } from '../api/fetch/partner';

export const linkAccountToPartner = async (partner: string, tokenKey: string, mlifeNumber: string) => {
  try {
    if (!!partner && !!tokenKey && !!mlifeNumber) {
      await linkPartner(
        mlifeNumber,
        JSON.stringify({ partner: { name: partner as string, tokenKey: tokenKey as string } }),
      );
    }
  } catch (error) {
    const redirectBase = `${window.location.protocol}//${window.location.host}/identity`;
    switch ((error as KnownError).code) {
      case 'E011':
        redirect(`${redirectBase}?message=${partner}_error_mismatch`);
        break;
      case 'E012':
        redirect(`${redirectBase}?message=${partner}_error_expired`);
        break;
      case 'E20':
      case 'E21':
      case 'E22':
        redirect(`${redirectBase}?message=${partner}_error_existing_profile`);
        break;
      default:
        if (partner) {
          redirect(`${redirectBase}?message=${partner}_error_general`);
        } else {
          throw new Error('An error occurred attempting to link your account');
        }
        break;
    }
  }
};

const redirect = (url: string) => {
  window.location.href = url;
};
